import script from "./SharesView.vue?vue&type=script&setup=true&lang=js"
export * from "./SharesView.vue?vue&type=script&setup=true&lang=js"

import "./SharesView.vue?vue&type=style&index=0&id=364a1f72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-364a1f72"]])

export default __exports__